import { render, staticRenderFns } from "./SettingsSms.vue?vue&type=template&id=5036b0cd&"
import script from "./SettingsSms.vue?vue&type=script&lang=js&"
export * from "./SettingsSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports